import { isEqual } from 'lodash';

const deleteHostSchedule = ({ accounts, accountIndex, weekIndex, handleHost, updateState }) => {
  const currentAccount = accounts[accountIndex];
  const { datas } = currentAccount;
  datas[weekIndex].schedules = datas[weekIndex].schedules.filter(
    (schedule) => !(isEqual(schedule.location, handleHost.location) && schedule.userId === handleHost.userId)
  );

  accounts[accountIndex].datas = datas;
  updateState({ accounts });
};

export default deleteHostSchedule;
